import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
    name: "GLOBAL_MIXINS",
    computed: {
        ...mapGetters(["GET_AUTH", "GET_USER_ID", "GET_USER"]),
    },
    methods: {
        //Скопировать текст
        copy(code) {
            this.$toast.info(`Скопировали : ${code}`);
            var copytext2 = document.createElement("input");
            copytext2.value = code;
            document.body.appendChild(copytext2);
            copytext2.select();
            document.execCommand("copy");
            document.body.removeChild(copytext2);
        },
        randomString(count = 8) {
            var text = "";
            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for (var i = 0; i < count; i++)
                text += possible.charAt(Math.floor(Math.random() * possible.length));
            return text;
        },
        // Сколько времени прошло 
        expectationDate(datetime, actual = new Date()) {
            function monthDays(year, month) {
                return month == 2
                    ? year % 4 != 0 || (year % 100 == 0 && year % 400 != 0)
                        ? 28
                        : 29
                    : (month < 8 && (month & 1) == 0) || (month > 7 && (month & 1) == 1)
                        ? 31
                        : 30;
            }

            function dateDiff(date1, date2) {
                //console.log(date1, date2)
                var years, months, days, hours, minutes, seconds;
                var y1, m1, d1, d2, dd;
                years = date2.getUTCFullYear() - (y1 = date1.getUTCFullYear());
                months = date2.getUTCMonth() - (m1 = date1.getUTCMonth());
                days = (d2 = date2.getUTCDate()) - (d1 = date1.getUTCDate());
                hours = date2.getUTCHours() - date1.getUTCHours();
                minutes = date2.getUTCMinutes() - date1.getUTCMinutes();
                seconds = date2.getUTCSeconds() - date1.getUTCSeconds();
                dd = 0;
                if (seconds < 0) {
                    seconds += 60;
                    minutes--;
                }
                if (minutes < 0) {
                    minutes += 60;
                    hours--;
                }
                if (hours < 0) {
                    hours += 24;
                    days--;
                    dd = 1;
                }
                if (days < 0) {
                    days = monthDays(y1, m1) - d1 + d2 - dd;
                    months--;
                }
                if (months < 0) {
                    months += 12;
                    years--;
                }
                return {
                    years: years,
                    months: months,
                    days: days,
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds,
                };
            }

            var d1 = new Date(datetime);
            var d2 = actual;

            var diff = dateDiff(d1, d2);
            var result = "";
            result += !diff.years == 0 ? diff.years + " лет, " : "";
            result += !diff.months == 0 ? diff.months + " месяцев, " : "";
            result += !diff.days == 0 ? diff.days + " дней, " : "";
            result += !diff.hours == 0 ? diff.hours + " ч. " : "";
            result += !diff.minutes == 0 ? diff.minutes + " м. " : "";
            result += !diff.seconds == 0 ? diff.seconds + " с. " : "";
            return result;
        },
        RandomMinMaxMixins(min, max) {
            return Math.random() * (max - min) + min;
        },
        RandomArrayMixins(items) {
            //console.log("items",items)
            if (items.length == 0) return false;
            return items[Math.floor(Math.random() * items.length)];
        },
        // 
        openDataInModal(mess, title = 'Данные') {

            try {
                var object = typeof mess === "string"
                    ? JSON.parse(mess)
                    : mess;

                var html = '<table class="table table-bordered mb-0" style="color: #fff;">';
                for (const key in object) {
                    html += `<tr>
                            <td style="width: 30%;">${key}</td> 
                            <td style="width: 60%;">
                                ${typeof object[key] === 'object' ? '<p style="color: red;margin: 0;">type object :</p>' + JSON.stringify(object[key]) : object[key]}
                            </td>
                            <td style="width: 10%;">
                                <button
                                    type="button"
                                    class="btn btn-success"
                                    style="padding: 10px"
                                    onclick=" 
                                    var copytext2 = document.createElement('input');
                                    copytext2.value = '${object[key]}';
                                    document.body.appendChild(copytext2);
                                    copytext2.select();
                                    document.execCommand('copy');
                                    document.body.removeChild(copytext2);
                                    alert('Скопировали : '+'${object[key]}')
                                    "
                                    >
                                    <i class="ri-file-copy-2-line" style="font-size: 24px"></i>
                                </button>
                            </td> 
                        </tr>`
                }
                this.$swal.fire({
                    title: title,
                    html: `${html}</table>`,
                    showConfirmButton: false,
                });
            } catch (error) {
                this.$swal.fire({
                    title: 'Данные не объект!',
                    html: `${mess}`,
                    showConfirmButton: false,
                });
            }

            function copy(code) {
                this.$toast.info(`Скопировали : ${code}`);
                var copytext2 = document.createElement("input");
                copytext2.value = code;
                document.body.appendChild(copytext2);
                copytext2.select();
                document.execCommand("copy");
                document.body.removeChild(copytext2);
            }
        },
        //делитель цифр 1 000 000
        divideNumberByPieces(x, delimiter = " ") {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
        },
        //Возвращаем дату в читабельном виде
        DateFilterMixins(value, format = "datetime") {
            if (!value) {
                return "";
            }

            const options = {};

            if (format.includes("datetime")) {
                options.day = "2-digit";
                options.month = "long";
                options.year = "numeric";
                options.hour = "2-digit";
                options.minute = "2-digit";
                options.second = "2-digit";
            }

            if (format.includes("date")) {
                options.day = "2-digit";
                options.month = "long";
                options.year = "numeric";
            }
            if (format.includes("date_min")) {
                options.day = "2-digit";
                options.month = "2-digit";
                options.year = "numeric";
            }

            if (format.includes("time")) {
                options.hour = "2-digit";
                options.minute = "2-digit";
                options.second = "2-digit";
            }

            return new Intl.DateTimeFormat("ru-RU", options).format(new Date(value));
        },
        //Отрисовать капчу
        recapRender() {
            grecaptcha.render("g-recaptcha", {
                sitekey: "6LdXBL4ZAAAAABUCvFbwRbIZPWC2a9Fgl1Zl-8rJ",
                theme: "dark",
            });
        },
        //вернуть результат капчи
        getRecap() {
            return grecaptcha.getResponse();
        },

        // Отправить уведомление пользователю
        async messengUserSupport(UID, text = false) {
            if (text) {
                return await this.$fetch({
                    url: `/api/pushBlockUser`,
                    body: {
                        UID,
                        text
                    },
                    loading: true,
                    alert: true
                });
            }
            this.$swal.fire({
                title: 'Уведоминить пользователя',
                html: `
                     <div style="display: flex;flex-wrap: wrap;justify-content: center;">
                        <div>
                            <input
                            type="checkbox"
                            id="subscribeNews"
                            name="subscribe"
                            onclick="$('#listMessUser').slideToggle(); $('#newMesBlock').slideToggle(); "
                            value="newsletter" />
                                <label for="subscribeNews">Написать своё сообщение?</label>
                         </div>
                         <select id="listMessUser" name="list1" style="height: 50px;white-space: pre-wrap;width: 100%;">
                             <option disabled >Выберите из списка</option>
                             <option>Смени аватарку, в игре и на сайте она отличается!!! </option>
                             <option>Смени аватарку, у с тобой стоят фейки! Не снимая предмета с продажи, поменяй аватарку на уникальную! А если это ты поставил два предмета - сними один с продажи! Должен быть только один предмет! </option>
                             <option>Смени аватарку, станок глючит и твоя аватарка не грузиться в игре. Загрузи новую аватарку на сайт и в игре. </option>
                             <option>Ты не выставил предмет на продажу! Сначала нужно посмотреть цену за столько выставлять, потом идёшь в игру и выставляешь прдмет на продажу, потом жмёшь на сайте кнопку я всё сделал! А не на оборот! </option>
                             <option>Напиши в тех.поддержку! Нужно что бы ты связался с тех поддержкой сайта!</option>
                             <option>Если не знаешь как выводить, или не хватает голды в игре на $l.stattrack} $l.model} $l.name} - напиши в тех поддержку в телеграмм. Там Рома - поможет с первым выводом с сайта. Ссылка на тех поддержку в правом меню сайта , там же есть ссылка на видео - как выводить. Если всё знаешь - не обращай внимание на это сообщение.</option>
                         </select>
                         
                         <div style="width: 100%;margin-top: 20px;background: #2d2d2d;display:none" id="newMesBlock">
                             <p style="font-size: 18px;">Введите своё сообщение</p>
                             <textarea id="newMesBlocktextarea" style="width: 100%;"></textarea>
                         </div>
                     </div>
                 `,
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Создать уведомление',
                preConfirm: async () => {
                    return await this.$fetch({
                        url: `/api/pushBlockUser`,
                        body: {
                            UID,
                            text: $('#subscribeNews').is(':checked') ? $("#newMesBlocktextarea").val() : $("#listMessUser").val()
                        },
                        loading: true,
                        alert: true
                    });
                },
            });
        },
    },
    async mounted() { },
};


